import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/app/HomeContent.tsx");
